(() => {
  let loaded = false;
  const load = () => {
    if (loaded || !window.themeTracking?.gtmId) return;
    loaded = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(window.themeTracking.gtmId)}`;
    document.head.appendChild(script);
  };

  ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(eventName => {
    window.addEventListener(eventName, load, { once: true, passive: true });
  });
  window.setTimeout(load, 4000);
})();
